import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useMakeModelSearchLink from './useMakeModelSearchLink';
import useMakeSearchLink from './useMakeSearchLink';

type BreadCrumbType = Array<{
  key: string;
  label: string;
  href: string;
}>;

export default function useConstructBreadcrumbs(): BreadCrumbType {
  const { make = '', model = '' } = useGetVehicleDetails();
  const makeSearchLink = useMakeSearchLink();
  const makeModelSearchLink = useMakeModelSearchLink();

  return [
    { key: 'all-cars', label: 'All Cars', href: '/cars' },
    {
      key: 'make',
      label: make,
      href: makeSearchLink
    },
    {
      key: 'model',
      label: model,
      href: makeModelSearchLink
    }
  ];
}
